angular.module('BillPay')
    .controller('NavigationCtrl', function ($scope, $rootScope, ProvidersService) {
        ProvidersService.getProvider().then(function (Provider) {
            $scope.Provider = Provider;
        });
    });
